/*eslint-disable array-callback-return */
import React, {  useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import Radio from "@material-ui/core/Radio";
import { useSelector, useDispatch } from "react-redux";
import formatCnpj from "@brazilian-utils/format-cnpj";
import { analytics, logEvent }  from "~/services/firebaseConfig";
import api from '~/services/api';
import { toast } from 'react-toastify';
import Loading from '~/components/layout/Loading';

import {
  DropdownMenuEconomic,
  DrodownButtonEconomic,
  DropdownItemEconomic,
  RadioButtonEconomic,
  DropdownWidth,
  AddressInfo,
  AddressText,
  AddressCardItem,
  AddressCard,
} from "./styles";
import { economicGroup } from "~/services/apiHandler";
import apiLapidar from '~/services/Lapidar/api';

export default function EconomicGroup(props) {
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useDispatch();
  const economicGroupReducer = useSelector(
    (state) => state.economicGroupReducer
  );
  const classificationReducer = useSelector((state) => state.classificationReducer);
  const userReducer = useSelector((state) => state.userReducer);
  let addressComponent = React.createRef();
  let DropdownItemEconomicStyle = DropdownItemEconomic;

  const cardGroupEconomic = React.forwardRef(({ children, onClick }, ref) => {
    DropdownItemEconomicStyle = {
      ...DropdownItemEconomicStyle,
      minWidth: addressComponent.current
        ? addressComponent.current.offsetWidth
        : null,
    };

    return (
      <div ref={addressComponent}>
        <AddressCard
          ref={ref}
          onClick={(event) => {
            event.preventDefault();
            onClick(event);
            dispatch({
              type: "SET_EXPAND",
              expand: !economicGroupReducer.expand,
            });
          }}
        >
          {props.children ? props.children : null}
        </AddressCard>
      </div>
    );
  });

  async function handleGroupEconomic(access_token) {
    setIsLoading(true)
    const header = {
      "Content-Type": "application/json",
      access_token,
    };
    const parameters = {
      method: "GET",
      headers: header,
    };
    economicGroup(parameters)
      .then(async (res) => {
        const response = res.data;
        let newStores = [];
        if (
          response &&
          response.economicGroups &&
          response.economicGroups.length > 0
        ) {
          const economicGroups = response.economicGroups;
          localStorage.setItem("groupEconomic", res.data.economicGroups[0].name)
          economicGroups.map((economicGroup) => {
            if (economicGroup.members && economicGroup.members.length > 0) {
              const members = economicGroup.members;
              members.map((member) => {
                const stores = member.stores;
                stores.map((store) => {
                  if (
                    newStores.filter(
                      newStore => newStore.storeId === store.storeId,
                    ).length === 0
                  ) {
                    if (store.active) {
                      if (localStorage.getItem("storeId") === store.storeId) {
                        localStorage.setItem("addressId", store.addressId);
                        localStorage.setItem("customerId", store.customerId);
                        localStorage.setItem("organizationId", store.organizationId);
                      }
                      newStores.push(store);
                    }
                  }
                  return;
                });
                return;
              });
            }
          });
        } else if (response && response.headQuarter) {
          const headQuarter = response.headQuarter;
          if (headQuarter.stores && headQuarter.stores.length > 0) {
            const stores = headQuarter.stores;
            stores.map((store) => {
              if (
                newStores.filter((newStore) => newStore.storeId === store.storeId)
                  .length === 0
              ) {
                if (store.active) {
                  if (localStorage.getItem("storeId") === store.storeId) {
                    localStorage.setItem("addressId", store.addressId);
                    localStorage.setItem("customerId", store.customerId);
                    localStorage.setItem("organizationId", store.organizationId);
                  }
                  newStores.push(store);
                }
              }
              return;
            });
          }
        }

        if (window.location.pathname !== "/lapidar/") {  
          if(localStorage.getItem('ownerid')) {
              let acessStore = []
              economicGroupReducer?.storesAccess?.map((storeAcess) => {
                newStores.map((store) => {
                  if(store.storeId === storeAcess.storeId) {
                    acessStore.push(store);
                  }
                  return;
                })
                return;
              })
              getStoresLapidar(acessStore);
              dispatch({ type: "SET_ECONOMIC_GROUPS", stores: acessStore });
              getOwneridInfos(localStorage.getItem("ownerid"));
              // setStoreToLocalStorage(acessStore[0]);
            } else {
              getStoresLapidar(newStores);
              dispatch({ type: "SET_ECONOMIC_GROUPS", stores: newStores });
            }
        }

        setIsLoading(false)
      })
      .catch((err) => {
        setIsLoading(false)
        console.log('err', err);
      });
  }

  function getStoresLapidar(economicGroups) {

    const setStoreToLocalStorageLapidar = (store) => {
      localStorage.setItem("external_load_id", store.storeId ? store.storeId : store.externalLoadId);
      localStorage.setItem("storeDocumentLapidar", store.storeDocument ? store.storeDocument : store.cnpj);
      localStorage.setItem("storeNameLapidar", store.name);
    }

    let selectedStore = economicGroups[0];
    const localStoreId = localStorage.getItem('storeId');
    if (localStoreId) {
      const mapStore = economicGroups.find(eg => eg.storeId === localStoreId);
      if (mapStore) {
        selectedStore = mapStore;
      }
    }
    setStoreToLocalStorageLapidar(selectedStore);

    if(economicGroups.length === 1) {
      const header = {
        'Content-Type': 'application/json',
        access_token: localStorage.getItem("access_token"),
      };
      const parameters = {
        method: 'GET',
        headers: header,
      };

      apiLapidar
      .get(`/store/summary?external_load_id=${localStorage.getItem("storeId")}`, parameters)
        .then((res) => {
          if(res.data) {
            verifyPendencies(res.data, economicGroups)
          }
        })
        .catch((err) => {
          dispatch({ type: "SET_HASCLASSIFICATION", hasClassification: false });
        })
    } else {

        const header = {
          'Content-Type': 'application/json',
          access_token: localStorage.getItem("access_token"),
        };
        const parameters = {
          method: 'GET',
          headers: header,
        };
        let stringStores = [];
        economicGroups.map((store) => {
          stringStores.push(`external_load_id_store[]=${store.storeId}`)
        })
        stringStores = stringStores.toString();
        stringStores = stringStores.replaceAll(',', '&');
        apiLapidar
        .get(`/store/economic-group?${stringStores}`, parameters)
        .then((res) => {
          if(res.data.stores.length > 0) {
            if(res.data.amount_can_subscribe > 0) {
              localStorage.setItem('canSubscribeStore', true);
              let storesAddProgram = []
                res.data.stores.map(element => {
                if(!element.isInProgram) {
                  storesAddProgram.push({
                    cnpj: element.cnpj,
                    externalLoadId: element.contaId ? element.contaId : element.externalLoadId,
                    name: element.name,
                    checked: element.isInProgram
                  });
                }
              });
              dispatch({ type: "SET_STORES_LAPIDAR_ADD", storesToAdd: storesAddProgram })
            } else {
              localStorage.setItem('canSubscribeStore', false);
            }
            let pendenciesOn = verifyPendencies(res.data, economicGroups);
            const hasStoreAdded = res.data.stores.find((item) => item.isInProgram === true);
            if(pendenciesOn && !hasStoreAdded) {
              dispatch({ type: "SET_PENDENCIESON", pendenciesOn: true });
            } else {
              dispatch({ type: "SET_PENDENCIESON", pendenciesOn: false });
              let storesSubscribed = []
              res.data.stores.map((store, index) => {
                if(store.externalLoadId && store.isInProgram) {
                  if(index < economicGroups.length) {
                    const item = economicGroups.find((item) => item.storeDocument === store.cnpj && item.storeId === store.externalLoadId);
                    item["checked"] = store.isInProgram;
                    storesSubscribed.push(item)
                  }
                }
                return;
              });

              let selectedStore = storesSubscribed[0];
              storesSubscribed.map(store => {
                if(store.storeId === localStorage.getItem("storeId")) {
                  selectedStore = store
                }
                return;
              })

              dispatch({ type: "SELECTED_STORE_LAPIDAR", selectedStoreLapidar: selectedStore });
              setStoreToLocalStorageLapidar(selectedStore);

              dispatch({ type: "SET_HASCLASSIFICATION", hasClassification: true });
              dispatch({ type: "SET_STORES_LAPIDAR", storesLapidar: storesSubscribed });
            }
          } else {
            dispatch({ type: "SET_PENDENCIESON", pendenciesOn: false });
            dispatch({ type: "SET_HASCLASSIFICATION", hasClassification: false });
          }
        })
        .catch((err) => {
          dispatch({ type: "SET_STORES_LAPIDAR", storesLapidar: economicGroups });
          console.log('err', err);
        })
    }
  }

  function verifyPendencies(result, economicGroups) {

    if(economicGroups.length === 1) {
      const header = {
        'Content-Type': 'application/json',
        access_token: localStorage.getItem("access_token"),
      };
      const parameters = {
        method: 'GET',
        headers: header,
      };
      apiLapidar
        .get(`/challenges/complete?external_load_id_store=${localStorage.getItem("storeId")}`, parameters)
        .then((res) => {
          let isElligible = {
            s5: false
          };
          res.data.challenges.map((element) => {
            if(element.code === "S5" && element.resultCounting === true) {
              isElligible.s5 = true
            }
          })
          if(isElligible.s5) {
            dispatch({ type: "SET_PENDENCIESON", pendenciesOn: false });
            dispatch({ type: "SELECTED_STORE_LAPIDAR", selectedStoreLapidar: economicGroups[0] });
            dispatch({ type: "SET_SELECTED_STORE", selectedStore: economicGroups[0] });
            setStoreToLocalStorageLapidar(economicGroups[0]);
            dispatch({ type: "SET_HASCLASSIFICATION", hasClassification: true });
            dispatch({ type: "SET_STORES_LAPIDAR", storesLapidar: economicGroups });
            return false
          } else {
            dispatch({ type: "SET_PENDENCIESON", pendenciesOn: true });
            dispatch({
              type: "SET_PENDENCIES",
              pendencies: {
                hasPendencies: true,
                storesSelected: {
                  s5: economicGroups,
                },
                rules: {
                  s5: false
                }
              }
            })
            return true
          }
        })
        .catch((err) => {
          const programClose = err?.response?.data?.error === "Program not found!" ? true : false
          if (programClose) {
            dispatch({ type: "SET_PROGRAM_CLOSE", programClose: true });
          }
        })
    } else {
      let storesSubscribed = []
      result.stores.map((store, index) => {
        if(store.externalLoadId) {
          if(index < economicGroups.length) {
            storesSubscribed.push(economicGroups[index])
          }
        }
      });
      if(
        result.counting_info.S5.search("is eligible") > 0
      ) {
        return false
      }
      if(
        result.counting_info.S5 === "all stores in this store group are eligible"
      ) {
        return false
      } else {
        if(
          result.counting_info.S5 !== "all stores in this store group are eligible" ||
          result.counting_info.S5.search("is eligible") < 0
        ) {
          let storesInPendencies = {
            s5: []
          }
          storesSubscribed.map((element) => {
            let searchResult = result.counting_info.S5.search(element.storeId)
            if(searchResult >= 0) {
              storesInPendencies.s5.push(element)
            }
            return;
          })
          dispatch({
            type: "SET_PENDENCIES",
            pendencies: {
              hasPendencies: true,
              storesSelected: storesInPendencies,
              rules: {
                s5: false
              }
            }
          })
          return true
        }
      }
    }
  }

  async function selectStore() {
    if (addressComponent.current) {
      DropdownItemEconomicStyle = {
        ...DropdownItemEconomicStyle,
        minWidth: addressComponent.current
          ? addressComponent.current.offsetWidth
          : null,
      };
    }
    let store = null;
    economicGroupReducer.stores.map((item) => {
      if (localStorage.getItem("storeId") === item.storeId) {
        store = economicGroupReducer.selectedStore
          ? economicGroupReducer.selectedStore
          : item;
      }
      return;
    });
      logEvent(analytics, 'troca_razao_social', {
      store,
    });
    setStoreToLocalStorage(store);
    const response = {
      ...userReducer.response,
      codeStore: `${store.storeCode}-${store.addressCode}`,
    };

    await dispatch({ type: "user/GET_ME_RESPONSE", response: response });
  }

  const setStoreToLocalStorage = (store) => {
    localStorage.setItem("storeId", store.storeId);
    localStorage.setItem("storeDocument", store.storeDocument);
    localStorage.setItem("storeName", store.name);
    localStorage.setItem(
      "codeStore",
      `${store.storeCode}-${store.addressCode}`,
    );
    localStorage.setItem("addressId", store.addressId);
    localStorage.setItem("customerId", store.customerId);
    localStorage.setItem("organizationId", store.organizationId);
    setStoreToLocalStorageLapidar(store)
  }

  const setStoreToLocalStorageLapidar = (store) => {
    localStorage.setItem("external_load_id", store.storeId ? store.storeId : store.externalLoadId);
    localStorage.setItem("storeDocumentLapidar", store.storeDocument ? store.storeDocument : store.cnpj);
    localStorage.setItem("storeNameLapidar", store.name);
  }

  const getOwneridInfos = (ownerid) =>{
    const access_token = localStorage.getItem("access_token");
    getUsersContacts(access_token, ownerid);
  }

  const getUsersContacts = (access_token, ownerid) => {
    const header = {
      'Content-Type': 'application/json',
      access_token,
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };

    api
      .get(`residential/store/v1/users/${ownerid}/contacts`, parameters)
      .then(res => {
        localStorage.setItem('contactIdSf', res.data[0].contactIdSf);
      })
      .catch(err => {
        const erro = err.response;
        if (erro) {
          const message = err.response.data.message;
          if (err.response.status !== 401) {
            toast.error(message);
          }else {
            localStorage.clear();
            window.location.href = '/acessar?error';
          }
        } else {
          if (err.response.status !== 401) {
            toast.error("Ocorreu um erro interno na aplicação");
          }
        }
      });
    };


  useEffect(() => {
    if (
      !localStorage.getItem("economic_group") &&
      economicGroupReducer.stores.length < 1
    ) {
      localStorage.setItem("economic_group", true);
      const accessToken = localStorage.getItem("access_token");
      handleGroupEconomic(accessToken);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if(economicGroupReducer.expand) {
        const accessToken = localStorage.getItem("access_token");
        handleGroupEconomic(accessToken);
      }
  }, [economicGroupReducer.expand]);


  useEffect(() => {
    if (economicGroupReducer.selectedStore) {
      if (
        economicGroupReducer.selectedStore.storeId !==
        localStorage.getItem("storeId")
      ) {
        if (economicGroupReducer.stores.length > 0) {
          selectStore();
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [economicGroupReducer.selectedStore]);

  const isMobile = window.screen.width < 771;

  return (
    <Dropdown
      onToggle={(isOpen) => {
        if (!isOpen) {
          dispatch({
            type: "SET_EXPAND",
            expand: !economicGroupReducer.expand,
          });
        }
      }}
      style={props.mobile ? DropdownWidth : {maxHeight: 60, marginBottom: 20, marginRight: window.location.pathname === "/universidade-ultragaz" ? 45 : 0 }}
    >
      <Dropdown.Toggle
        id="dropdown-custom-components"
        as={cardGroupEconomic}
        style={DrodownButtonEconomic}
      />
      {
        props.lapidar && window.location.pathname !== "/universidade-ultragaz" || window.location.pathname === "/lapidar/ciclo-de-apuracao/adicaoRevenda" ? (
          <DropdownMenuEconomic lapidar={props.lapidar || window.location.pathname === "/lapidar/ciclo-de-apuracao/adicaoRevenda"}>
            {isLoading ? (
              <Loading margin={`${isMobile ? '0% auto' : '5% auto'}`} />
            ) : (
              <>            
                {classificationReducer.storesLapidar.map((store) => (
                  <Dropdown.Item
                    onClick={() => {
                      dispatch({ type: "SELECTED_STORE_LAPIDAR", selectedStoreLapidar: store });
                       dispatch({ type: "SET_SELECTED_STORE", selectedStore: store });
                      dispatch({
                        type: "SET_EXPAND",
                        expand: !economicGroupReducer.expand,
                      });
                      setStoreToLocalStorageLapidar(store);
                      if (props.lapidar) {
                          window.location.reload();
                      }
                    }}
                    style={DropdownItemEconomicStyle}
                    key={store.storeId ? store.storeId : store.externalLoadId}
                  >
                    <AddressCardItem>
                      <Radio
                        color="primary"
                        checked={store.storeId ?
                        store.storeId === localStorage.getItem("external_load_id") :
                        store.externalLoadId === localStorage.getItem("external_load_id")}
                        style={RadioButtonEconomic}
                      />
                      <AddressInfo>
                        <AddressText>{store.name}</AddressText>
                        <AddressText>
                          CNPJ: {store.storeDocument ? formatCnpj(store.storeDocument) : formatCnpj(store.cnpj)}
                        </AddressText>
                      </AddressInfo>
                    </AddressCardItem>
                  </Dropdown.Item>
                ))}
             </>
            )}
          </DropdownMenuEconomic>
        ) : (
          <DropdownMenuEconomic lapidar={props.lapidar && window.location.pathname !== "/lapidar/ciclo-de-apuracao/adicaoRevenda"}>
            {economicGroupReducer.stores.map((store) => (
              <Dropdown.Item
                onClick={() => {
                  dispatch({ type: "SET_SELECTED_STORE", selectedStore: store });
                  dispatch({
                    type: "SET_EXPAND",
                    expand: !economicGroupReducer.expand,
                  });
                  if(classificationReducer.storesLapidar) {
                    classificationReducer.storesLapidar.map(storeLapidar => {
                      if(storeLapidar.storeId === store.storeId) {
                        dispatch({ type: "SELECTED_STORE_LAPIDAR", selectedStoreLapidar: store });
                        setStoreToLocalStorageLapidar(store);
                      }
                      return;
                    })
                  }
                  {/* //TODO challenge-lapidar */}
                  // setStoreToLocalStorage(store);
                  if (props.lapidar) {
                      window.location.reload();
                  }
                }}
                style={DropdownItemEconomicStyle}
                key={store.storeId ? store.storeId : store.externalLoadId}
              >
                <AddressCardItem>
                  <Radio
                    color="primary"
                    checked={store.storeId ?
                    store.storeId === localStorage.getItem("storeId") :
                    store.externalLoadId === localStorage.getItem("external_load_id")}
                    style={RadioButtonEconomic}
                  />
                  <AddressInfo>
                    <AddressText>{store.name}</AddressText>
                    <AddressText>
                      CNPJ: {store.storeDocument ? formatCnpj(store.storeDocument) : formatCnpj(store.cnpj)}
                    </AddressText>
                  </AddressInfo>
                </AddressCardItem>
              </Dropdown.Item>
            ))}
          </DropdownMenuEconomic>
        )
      }
    </Dropdown>
  );
}
